import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: '太陽光発電の知識がなくても案件を紹介できますか？',
      answer: 'はい、全く問題ありません。施主様への商談から設計、施工、アフターフォローまで全てライズコーポレーションが代行いたします。工務店様は案件情報（住所・連絡先）をご提供いただくだけでOKです。'
    },
    {
      question: '紹介料はどのくらいもらえますか？',
      answer: '案件の規模や内容によって異なりますが、業界トップクラスの紹介料をお支払いいたします。詳細な料金体系については、お問い合わせ時に個別にご説明させていただきます。'
    },
    {
      question: '施主様からのクレームが心配です',
      answer: '施工後のクレームやメンテナンス対応も全てライズコーポレーションが責任を持って対応いたします。メンテナンス事業も自社運営しておりますので、工務店様にご迷惑をおかけすることはありません。'
    },
    {
      question: '対応エリアはどこまでですか？',
      answer: '関西全域（大阪・兵庫・滋賀・和歌山・奈良・京都）を中心に、関東・東海・中国・四国・九州に対応。その他のエリアについてもお気軽にご相談ください。'
    },
    {
      question: '案件紹介から収益化までどのくらいかかりますか？',
      answer: '案件の内容（新築・既築）にもよりますが、通常は施工完了後に紹介料をお支払いいたします。案件紹介から施工完了まで約1ヶ月〜6ヶ月程度が目安となります。'
    },
    {
      question: '小さな案件やご相談レベルの案件でも対応してもらえますか？',
      answer: 'はい、住宅用の小規模案件から産業用の大規模案件まで幅広く対応しております。案件の大小に関わらず、お気軽にご相談・ご紹介ください。'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-12 md:py-24 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-16">
          <div className="inline-flex items-center gap-2 bg-white text-teal-600 px-4 py-1.5 md:px-5 md:py-2 rounded-full text-xs md:text-sm font-semibold mb-4 md:mb-6 shadow-md border border-teal-100">
            <i className="ri-question-answer-line"></i>
            FAQ
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-gray-800 mb-3 md:mb-4">
            よくある<span className="text-teal-500">ご質問</span>
          </h2>
          <div className="w-16 md:w-20 h-1 md:h-1.5 bg-gradient-to-r from-teal-400 to-emerald-400 mx-auto mt-4 md:mt-6 rounded-full"></div>
        </div>

        <div className="space-y-3 md:space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className={`bg-white rounded-xl md:rounded-2xl border-2 transition-all duration-300 overflow-hidden ${
                openIndex === index 
                  ? 'border-teal-300 shadow-lg' 
                  : 'border-gray-100 hover:border-teal-200 shadow-md'
              }`}
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-4 py-3 md:px-6 md:py-5 flex items-center justify-between text-left cursor-pointer"
              >
                <div className="flex items-center gap-3 md:gap-4">
                  <div className={`w-8 h-8 md:w-10 md:h-10 rounded-lg md:rounded-xl flex items-center justify-center text-sm md:text-lg font-bold transition-all duration-300 flex-shrink-0 ${
                    openIndex === index 
                      ? 'bg-gradient-to-br from-teal-400 to-emerald-400 text-white' 
                      : 'bg-teal-50 text-teal-500'
                  }`}>
                    Q
                  </div>
                  <span className="font-bold text-gray-800 text-sm md:text-base pr-2 md:pr-4">
                    {faq.question}
                  </span>
                </div>
                <div className={`w-6 h-6 md:w-8 md:h-8 rounded-full flex items-center justify-center transition-all duration-300 flex-shrink-0 ${
                  openIndex === index 
                    ? 'bg-teal-100 rotate-180' 
                    : 'bg-gray-100'
                }`}>
                  <i className="ri-arrow-down-s-line text-lg md:text-xl text-gray-600"></i>
                </div>
              </button>
              
              <div className={`transition-all duration-300 ease-in-out ${
                openIndex === index 
                  ? 'max-h-96 opacity-100' 
                  : 'max-h-0 opacity-0'
              }`}>
                <div className="px-4 pb-4 md:px-6 md:pb-6">
                  <div className="flex gap-3 md:gap-4 pt-2 border-t border-gray-100">
                    <div className="w-8 h-8 md:w-10 md:h-10 rounded-lg md:rounded-xl bg-emerald-50 flex items-center justify-center text-sm md:text-lg font-bold text-emerald-500 flex-shrink-0 mt-2 md:mt-3">
                      A
                    </div>
                    <p className="text-gray-600 leading-relaxed pt-2 md:pt-3 text-sm md:text-base">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 md:mt-12 bg-gradient-to-r from-teal-50 to-emerald-50 rounded-2xl md:rounded-3xl p-5 md:p-8 text-center border border-teal-100">
          <div className="flex items-center justify-center gap-2 md:gap-3 mb-2 md:mb-3">
            <span className="text-2xl md:text-3xl">💬</span>
            <h3 className="text-base md:text-xl font-bold text-gray-800">
              その他のご質問はお気軽にどうぞ
            </h3>
          </div>
          <p className="text-gray-600 text-xs md:text-sm mb-4 md:mb-5">
            上記以外のご質問やご相談がございましたら、お気軽にお問い合わせください。
          </p>
          <a 
            href="#contact" 
            className="inline-flex items-center gap-2 bg-gradient-to-r from-teal-400 to-emerald-400 text-white px-6 py-2.5 md:px-8 md:py-3 rounded-full font-bold shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-0.5 cursor-pointer whitespace-nowrap text-sm md:text-base"
          >
            <i className="ri-mail-send-line"></i>
            お問い合わせはこちら
          </a>
        </div>
      </div>
    </section>
  );
}